import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createCollaboratorAsync, deleteCollaboratorAsync, disableCollaboratorAsync, enableCollaboratorAsync, getAllCollaboratorsAsync, getCollaboratorByIdAsync, updateCollaboratorAsync, getCollaboratorsByEventAsync, getAllCollaboratorsByCompanyAsync } from './collaboratorThunk';
const initialState = {
    status: APIStatus.IDLE,
    collaborators: [],
    collaboratorsTotalCount: 0,
    collaborator: undefined,
    eventCollaborators: []
};
export const collaboratorSlice = createSlice({
    name: 'collaborator',
    initialState,
    reducers: {
        clearEventCollaborators: (state) => {
            state.eventCollaborators = [];
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createCollaboratorAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createCollaboratorAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.collaborator = action.payload;
        })
            .addCase(createCollaboratorAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateCollaboratorAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateCollaboratorAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.collaborator = action.payload;
        })
            .addCase(updateCollaboratorAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllCollaboratorsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllCollaboratorsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.collaborators = action.payload.items || [];
            state.collaboratorsTotalCount = action.payload.totalCount || 0;
        })
            .addCase(getAllCollaboratorsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getCollaboratorByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getCollaboratorByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.collaborator = action.payload;
        })
            .addCase(getCollaboratorByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteCollaboratorAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteCollaboratorAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deleteCollaboratorAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(enableCollaboratorAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(enableCollaboratorAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(enableCollaboratorAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(disableCollaboratorAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(disableCollaboratorAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(disableCollaboratorAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getCollaboratorsByEventAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getCollaboratorsByEventAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.eventCollaborators = action.payload;
        })
            .addCase(getCollaboratorsByEventAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllCollaboratorsByCompanyAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllCollaboratorsByCompanyAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.collaborators = action.payload;
        })
            .addCase(getAllCollaboratorsByCompanyAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { clearEventCollaborators } = collaboratorSlice.actions;
export default collaboratorSlice.reducer;
